import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CancellableStatus from 'models/cancellable-status';

const propTypes = {
  cancellableStatus: PropTypes.instanceOf(CancellableStatus).isRequired,
};

export const CHECK_ICON = 'iconified-font iconified-circle-check';
export const X_ICON = 'iconified-font iconified-button-close';
export const getIcon = cancellableStatus => (cancellableStatus.cancellableNow ? CHECK_ICON : X_ICON);

const MinimalBadges = ({ cancellableStatus }) => (
  <Fragment>
    <div className="row">
      <div className="col-xs-12 margin-bottom-10 text-color-dark-slate text-weight-book">
        <span className={`${getIcon(cancellableStatus)} position-absolute text-color-grey text-size-18`} />
        <div className="cancellable-status-text">{cancellableStatus.message}</div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 text-color-dark-slate text-weight-book">
        <span className="iconified-font iconified-lock margin-right-10 text-color-grey text-size-18" />
        Secure checkout
      </div>
    </div>
  </Fragment>
);

MinimalBadges.propTypes = propTypes;

export default MinimalBadges;
